import React from 'react';
import { useParams } from 'react-router-dom';
import { H1, Text } from '../components/ui/Typography';
import { Card } from '../components/ui/Card';
import SafeIcon from '../common/SafeIcon';
import { motion } from 'framer-motion';
import { translations } from '../translations';

const HowItWorks = () => {
  const { lang = 'nl' } = useParams();
  const t = translations[lang]?.howItWorks || translations.nl.howItWorks;

  return (
    <div className="max-w-5xl mx-auto px-6 py-20">
      <div className="text-center mb-24 max-w-3xl mx-auto">
        <H1 className="mb-6">{t.title}</H1>
        <Text>{t.subtitle}</Text>
      </div>
      <div className="space-y-8 relative before:absolute before:inset-0 before:ml-[3.25rem] md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-zinc-200">
        {t.steps.map((step, index) => (
          <motion.div 
            initial={{ opacity: 0, y: 20 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            viewport={{ once: true }} 
            key={index} 
            className={`relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active`}
          >
            <div className="flex items-center justify-center w-10 h-10 rounded-full border-4 border-white bg-zinc-900 text-white shadow shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 relative z-10 font-semibold text-sm">
              {step.num}
            </div>
            <Card className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-8 hover:shadow-xl transition-shadow bg-white/80 backdrop-blur">
              <div className="w-12 h-12 bg-zinc-50 rounded-xl flex items-center justify-center mb-4 text-zinc-900">
                <SafeIcon name={step.icon} className="text-xl" />
              </div>
              <h3 className="text-xl font-semibold mb-3">{step.title}</h3>
              <Text subtle className="text-sm">{step.desc}</Text>
            </Card>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default HowItWorks;